module.exports = __webpack_public_path__ + "static/media/Oswald-Regular.e1996192.ttf";